function initializeNavClickEventListeners() {
    const navButtons = document.querySelectorAll(
        ".rbsv4-featured-cards__navigation-item",
    );
    if (navButtons.length === 0) {
        return;
    }

    navButtons.forEach((navButton) =>
        navButton.addEventListener("click", onClick),
    );
}

function onClick(event) {
    const navButton = event?.target?.closest(
        ".rbsv4-featured-cards__navigation-item",
    );
    if (!navButton || navButton.classList.contains("active")) {
        return;
    }

    const index = Number(navButton.getAttribute("data-index"));
    if (index === null) {
        return;
    }

    const featuredImages = document.querySelectorAll(
        ".rbsv4-featured-cards__image-container",
    );
    if (featuredImages.length === 0 || featuredImages.length - 1 < index) {
        return;
    }

    const nextActiveImage = featuredImages[index];
    if (nextActiveImage.classList.contains("active")) {
        return;
    }

    const prevActiveImage = document.querySelector(
        ".rbsv4-featured-cards__image-container.active",
    );
    const prevActiveNavButton = document.querySelector(
        ".rbsv4-featured-cards__navigation-item.active",
    );
    prevActiveImage?.classList.toggle("active");
    nextActiveImage.classList.toggle("active");
    prevActiveNavButton?.classList.toggle("active");
    navButton.classList.toggle("active");

    const quoteElement = document.querySelector(
        ".rbsv4-featured-cards__item-quote",
    );
    const descriptionElement = document.querySelector(
        ".rbsv4-featured-cards__item-description",
    );
    const nameElement = document.querySelector(
        ".rbsv4-featured-cards__item-name",
    );
    const roleElement = document.querySelector(
        ".rbsv4-featured-cards__item-role",
    );

    if (index === 0) {
        quoteElement.textContent =
            "“At the age of 63, I feel like I have the same strength and endurance from my 30s.“";
        quoteElement.style.display = "block";
        descriptionElement.textContent = `Bryan Nettles, Founder and CEO of Renue By Science, has a lifelong focus on nutrition, exercise, and
              longevity science. His personal health journey - recovering from prostate cancer - deepened his commitment
              to research and healthy aging. Driven to educate and empower others, he founded the company to make
              science-backed longevity solutions more accessible, helping people live longer, stronger lives at any
              stage.`;
        nameElement.textContent = "Bryan Nettles";
        roleElement.textContent = "Founder & CEO";
    } else if (index === 1) {
        quoteElement.textContent = "";
        quoteElement.style.display = "none";
        descriptionElement.textContent =
            "Dr. Rebecca Crews holds a PhD in Biochemical and Molecular Nutrition from the Friedman School at Tufts University. Her research has spanned the Air Force Research Laboratory, Tufts, and Texas State, with published work on NMN supplementation, metabolic variability, and the science of NAD+ in healthy aging. At Renue By Science, she leads the research program and translates the latest longevity science into the formulas you find in our shop.";
        nameElement.textContent = "Dr. Rebecca Crews";
        roleElement.textContent = "Research Director";
    } else {
        quoteElement.textContent = "";
        quoteElement.style.display = "none";
        descriptionElement.textContent =
            "Dr. Clark Driggers is the Chief Medical Advisor at Renue By Science, with a clinical focus on wellness, healthy aging, and regenerative medicine. He works at the intersection of clinical practice and longevity research, helping shape the science behind our formulas. His perspective grounds our work in what actually matters to patients in the real world: products that are safe, effective, and built on evidence.";
        nameElement.textContent = "Dr. Clark Driggers";
        roleElement.textContent = "Chief Medical Advisor";
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initializeNavClickEventListeners();
});
